<template lang="pug">
    section(:style="sectionStyle")#banner
        .img
            img(:src="background", :alt="titulo")
        h1 {{ titulo }}
        ul.vantagens
            li(v-for="vantagem in vantagens").vantagem {{ vantagem }}
        router-link(to="/politica-de-precos", v-if="politicas").politica ¹ Consulte fael.edu.br/politica-de-precos
</template>

<script>
export default {
    name: "section-banner",
    props: {
        background: {
            type: String,
            required: true
        },
        cores: {
            type: Array,
            required: true
        },
        politicas: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            required: true
        },
        vantagens: {
            type: Array,
            required: true
        },
    },
    computed: {
        sectionStyle() {
            return {
                background: `linear-gradient(to right, ${this.cores.toString()})`
            }
        }
    },
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>